import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  fileFormat,
  emptyString,
  roleTypeEnums,
  loginConstants,
  imageSizeAlert,
  groupsConstants,
  managerDropDown,
  userBrandDropDown,
  franchiseDropDown,
  userProfileDropDown,
  franchiseOptionLabel,
  userPermissionsConstants,
  profileTypeDropdownNames,
  LoginRoles,
  toastTypes,
  phoneConstants,
  modalSize,
  BUTTON_TEXT,
  userProfileImageLimits,
  userProfileLabels,
  EMPTY_ARRAY_LENGTH,
} from "../../constants";
import { storesConstants } from "../../../admin-screens/constants";
import { managersConstants } from "../../../group-screens/constants";
import { getItemFromStorage } from "../../../../system";
import {
  useSpinner,
  Spinner,
  getClassName,
  loadingIndicator,
  ValueContainer,
  isManagerAdmin,
  isGroupAdmin,
  isSuperOrBrandAdmin,
  customToast,
  getUserFormSelectStyles,
  handleAsyncAction,
} from "../../../../shared";
import {
  getConfirmationModal,
  resetPasswordUserPermission,
} from "../../../../shared/components/popups/allModals";
import { groupsActions, userPermissionsActions } from "../../redux/actions";
import { loginActions } from "../../../../redux/actions";
import { storeActions } from "../../../admin-screens/redux/actions";
import { managersActions } from "../../../group-screens/redux/actions";
import userLogo from "../../../../assets/images/user-profile-logo.png";
import { generateImagePath } from "../../../../shared/components/sidebarContainer/utility";

const {
  GROUP,
  GROUPS,
  BRANDS,
  MANAGER,
  BRAND_ADMIN,
  SUPER_ADMIN,
  FRANCHISE_ID,
  PROFILE_TYPE,
  USER_PERMISSION_DATA,
} = userPermissionsConstants;

const { ADD, ADD_FRANCHISE } = franchiseOptionLabel;

const UserProfile = (props) => {
  const {
    storesReducer: { allBrands },
    groupsReducer: { groups, groupCreated },
    userPermissionsReducer: { userPermissionData },
    managersReducer: { allLocations },
    getGroups,
    getUserById,
    getAllBrands,
    authenticationUser,
    deleteUserProfileImage,
    updateUserProfilePic,
    updateUsers,
    getBrandlocations,
    imagePathFromHub,
  } = props;

  const getFranchise = useRef(true);

  let localRole = getItemFromStorage(loginConstants.ROLE);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  //Initialize states
  const [brandName, setBrandName] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [storesName, setStoresName] = useState([
    { name: "Selected Stores", value: "" },
  ]);
  const [franchiseName, setFranchiseName] = useState({});
  const [modalElement, setModalElement] = useState(null);
  const [rowData, setRowData] = useState({});

  // Show loading while a request is running.
  const spinner = useSpinner();

  //Get data
  const getData = () => {
    getUserById(authenticationUser.id);
    getAllBrands(true);
  };

  //Load new data after the user permission is successfully submitted
  const loadNewData = () => {
    getData();
  };

  //Handle change function to save changes in state
  const handleChange = (e, flag, fieldName) => {
    //If handle change function call for react then run else statement
    if (!flag) {
      setRowTargetValue(e);
    } else {
      setRowTargetValue(e, flag, fieldName);
    }
  };

  //Handle brand change function to save changes in state
  const handleBrandChange = (e) => {
    let brandId = e.id;
    if (
      brandId &&
      (rowData?.roleId === roleTypeEnums.GROUP ||
        rowData?.roleId === roleTypeEnums.MANAGER)
    ) {
      getGroups(brandId);
    }
    if (
      brandId &&
      rowData?.roleId === roleTypeEnums.MANAGER &&
      rowData?.groupId
    ) {
      getBrandlocations(rowData?.groupId);
    }
    setRowTargetValue(e, true, "brandId");
  };

  //OnSubmit function to submit all the data on submission
  const onSubmit = () => {
    let newData = {
      name: rowData?.name,
      email: rowData?.email,
      phoneNumber: `${phoneConstants.COUNTRY_CODE}${rowData?.phoneNumber}`,
      roleId: rowData?.roleId,
      id: rowData?.id,
    };

    if (localRole === BRAND_ADMIN) {
      newData = {
        ...newData,
        brandId: rowData?.brandId,
        brandIds: rowData?.brandIds,
      };
    } else if (localRole === GROUP) {
      newData = {
        ...newData,
        brandId: rowData?.brandId,
        groupId: rowData?.groupId,
      };
    } else if (localRole === MANAGER) {
      newData = {
        ...newData,
        brandId: rowData?.brandId,
        groupId: rowData?.groupId,
        storeIds: rowData?.storeIds,
      };
    }

    updateUsers(newData, authenticationUser.id, true);
  };

  //Function to set rowData and email validation state
  const setRowTargetValue = (e, flag, name) => {
    if (!flag) {
      setRowData({
        ...rowData,
        [e.target.name]: e.target.value,
      });
    } else {
      setRowData({
        ...rowData,
        [name]: e.value || e.id,
      });
    }
  };

  //Function to set name of profile type dropdown
  const handleProfileTypeName = (roleId) => {
    if (roleId === roleTypeEnums.SUPER_ADMIN) {
      return profileTypeDropdownNames.SUPER_ADMIN;
    } else if (roleId === roleTypeEnums.BRAND_ADMIN) {
      return profileTypeDropdownNames.BRAND_ADMIN;
    } else if (roleId === roleTypeEnums.GROUP) {
      return profileTypeDropdownNames.GROUP;
    } else if (roleId === roleTypeEnums.MANAGER) {
      return profileTypeDropdownNames.MANAGER;
    } else {
      return PROFILE_TYPE;
    }
  };

  const getOptionLabel = (option) => {
    return option.id === ADD ? (
      <span style={{ color: "blue" }}>{option.name}</span>
    ) : (
      option.name
    );
  };

  const getOptionStyle = (styles, { data }) => {
    return data.id === ADD
      ? {
          ...styles,
          color: "blue",
          cursor: "pointer",
        }
      : styles;
  };

  const handleFranchiseSelect = (e) => {
    setFranchiseName(e);
    handleChange(e, true, FRANCHISE_ID);

    if (rowData?.roleId === roleTypeEnums.MANAGER && e.id) {
      getBrandlocations(e.id);
    }
  };

  //To open the modal
  const openModal = () => {
    setShowModal(true);
  };

  //To close the modal
  const closeModal = () => {
    setShowModal(false);
  };

  //Setting modal component
  const setComponent = (component) => {
    setModalElement(component);
    openModal();
  };

  //Get User confirmation delete modal
  const resetPasswordModal = (userId) => {
    setComponent(
      resetPasswordUserPermission({
        onClose: closeModal,
        userId: userId,
      })
    );
  };

  //Delete themeSetting logo modal
  const deleteImage = (e) => {
    e.stopPropagation();
    setComponent(
      getConfirmationModal({
        onClose: closeModal,
        Title: BUTTON_TEXT.CONFIRM,
        message: userProfileLabels.DELETE_IMAGE_MESSAGE,
        ModalSize: modalSize.MODAL_SIZE_MEDIUM,
        onConfirm: () => {
          handleAsyncAction(deleteUserProfileImage(authenticationUser.id), {
            onSuccess: closeModal,
          });
        },
      })
    );
  };

  //Handle image size for uploading
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if (!fileFormat.BASE_64_IMAGE_TYPES.includes(file.type)) {
      customToast(
        imageSizeAlert.IMAGE_FORMAT_ERROR_ALL_SUPPORTED,
        toastTypes.ERROR
      );
      e.target.value = "";
      return;
    }

    const img = new Image();
    const maxSizeBytes = userProfileImageLimits.MAX_BYTES;

    // Check if the file size is within the allowed limit

    img.onload = function () {
      if (file.size > maxSizeBytes) {
        //Display an error message on uploading image
        alert(imageSizeAlert.IMAGE_SIZE_ERROR_2MB);
        e.target.value = emptyString;
      } else {
        //Image is within the allowed size to upload
        readURL(e.target);
        uploadProfilePic(file);
      }
    };

    img.src = URL.createObjectURL(file);
  };

  // Function to display the selected image
  const readURL = (input) => {
    if (input?.files?.[0]) {
      const reader = new FileReader();

      reader.onload = function (e) {
        // You can display the selected image here
        const imageElement = document.getElementById("photo");
        imageElement.src = e.target.result;
      };

      reader.readAsDataURL(input.files[0]);
    }
  };

  const uploadProfilePic = (selectedFile) => {
    let formdata = new FormData();
    formdata.append("profilePic", selectedFile);

    updateUserProfilePic(formdata);
  };

  const profileTypeOptions = () => {
    let option = [{ value: emptyString, name: PROFILE_TYPE }];

    switch (localRole) {
      case SUPER_ADMIN:
        return [...option, ...userProfileDropDown];
      case BRAND_ADMIN:
        return [...option, ...userBrandDropDown];
      case GROUP:
        return [...option, ...franchiseDropDown];
      case MANAGER:
        return [...managerDropDown];
      default:
        return []; // Empty options array for other roles or no role specified
    }
  };

  //Getting all the users
  useEffect(() => {
    loadNewData();
    // eslint-disable-next-line
  }, [userPermissionData]);

  //Getting all the users
  useEffect(() => {
    if (getFranchise.current) {
      getFranchise.current = false;
      return;
    }
    getGroups(rowData?.brandId);
    // eslint-disable-next-line
  }, [groupCreated]);

  //Get groups and locations if we change brandId
  const initialRender = useRef(true);
  useEffect(() => {
    const isGroupWithBrandId =
      rowData?.roleId === roleTypeEnums.GROUP && rowData?.brandId;

    if (initialRender.current) {
      initialRender.current = false;
    } else if (isGroupWithBrandId) {
      getGroups(rowData?.brandId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData?.brandId, rowData?.roleId]);

  //Getting names against brandId, locationId and groupId
  useEffect(() => {
    //If allBrands from reducers is present then execute the following
    if (allBrands && rowData?.brandId) {
      let obj = allBrands?.find((brand) => brand.id === rowData?.brandId);
      setBrandName(obj);
    }
    //If groups from reducers is present then execute the following
    if (groups?.data && rowData?.groupId) {
      let obj = groups?.data?.find((group) => group.id === rowData?.groupId);
      setFranchiseName(obj);
    }
    //If stores from reducers is present then execute the following
    if (allLocations?.data && rowData?.storeIds) {
      const filteredLocations = allLocations?.data.filter((location) =>
        rowData?.storeIds?.includes(location.id)
      );
      setStoresName(filteredLocations);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allBrands, groups?.data, allLocations?.data, rowData]);

  useEffect(() => {
    if (localRole === GROUP && groups?.data?.length) {
      handleFranchiseSelect(groups?.data[0]);
    }
    // eslint-disable-next-line
  }, [groups]);

  //Handle auto select dropdown on every user type
  useEffect(() => {
    if (localRole !== SUPER_ADMIN && allBrands.length) {
      handleBrandChange(allBrands[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allBrands]);

  useEffect(() => {
    if (Object.keys(authenticationUser || {}).length) {
      setRowData({
        ...authenticationUser,
        ...(authenticationUser.phoneNumber.length > phoneConstants.LENGTH && {
          phoneNumber: authenticationUser.phoneNumber.replace(
            phoneConstants.COUNTRY_CODE,
            emptyString
          ),
        }),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticationUser]);

  return (
    <>
      {/*Modal here */}
      {showModal && modalElement}
      {spinner(USER_PERMISSION_DATA) ? <Spinner /> : <></>}
      {/*End Modal */}
      <div className="py-3 container-fluid">
        <div className="notification-form card shadow px-4 pt-2 my-4">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row new-user">
                <div className="col-12">
                  <h5>Update User</h5>
                </div>
              </div>
              <div className="row">
                <div className="mb-3 pt-2 col-lg-6 col-sm-12 d-flex flex-md-row flex-column justify-content-between align-items-center">
                  <div className="col-lg-3 col-md-4 d-flex">
                    <img
                      className="rounded-circle img-fluid h100"
                      src={
                        rowData?.logoUrl ||
                        generateImagePath(imagePathFromHub, userLogo)
                      }
                      alt="profilePic"
                      id="photo"
                      height={userProfileImageLimits.PHOTO_SIZE_PX}
                      width={userProfileImageLimits.PHOTO_SIZE_PX}
                    />
                    {rowData?.logoUrl && (
                      <FontAwesomeIcon
                        icon={faTimes}
                        size="x1"
                        className="remove-button ps-2"
                        data-testid="delete-profile-img"
                        onClick={(e) => deleteImage(e)}
                      />
                    )}
                  </div>
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(e)}
                    id="uploadBtn"
                    data-testid="upload-profile-pic"
                    accept={fileFormat.IMG_TYPES}
                  />
                  <label
                    htmlFor="uploadBtn"
                    id="ProfilePicPosition"
                    name="Img"
                    className="user-fields"
                  >
                    <span>Upload Picture</span>
                  </label>
                </div>
              </div>
              <Row className="g-3">
                <Col md={6}>
                  <Row className="g-3">
                    <Col
                      xs={12}
                      className="d-flex align-items-baseline justify-content-between w-100"
                    >
                      <h6 htmlFor="role" className="mt-2 col-3 col-lg-3">
                        Profile Type:
                      </h6>
                      <Controller
                        name="roleId"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            value={[
                              {
                                value: rowData?.roleId || emptyString,
                                name: handleProfileTypeName(rowData?.roleId),
                              },
                            ]}
                            options={profileTypeOptions()}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            getOptionValue={(option) => option.value}
                            getOptionLabel={(option) => option.name}
                            placeholder={PROFILE_TYPE}
                            isSearchable={true}
                            styles={getUserFormSelectStyles(
                              errors.roleId,
                              rowData?.roleId
                            )}
                            className={`w-100 font-14-px text-secondary`}
                            isDisabled
                          />
                        )}
                        rules={{ required: !rowData?.roleId }}
                      />
                    </Col>
                    {localRole !== LoginRoles.SUPER_ADMIN && (
                      <Col
                        xs={12}
                        className="d-flex align-items-baseline justify-content-center"
                      >
                        <h6 htmlFor="brand" className="mt-2 col-3 col-lg-3">
                          Brand:
                        </h6>
                        <Controller
                          name="brandId"
                          control={control}
                          render={({ field }) => (
                            <Select
                              isMulti={isSuperOrBrandAdmin()}
                              {...field}
                              value={
                                localRole !== SUPER_ADMIN
                                  ? allBrands
                                  : [
                                      {
                                        id: brandName?.id || emptyString,
                                        name: brandName?.name || BRANDS,
                                      },
                                    ]
                              }
                              options={
                                localRole === SUPER_ADMIN
                                  ? [
                                      { id: emptyString, name: BRANDS },
                                      ...allBrands,
                                    ]
                                  : allBrands
                              }
                              components={{
                                IndicatorSeparator: () => null,
                                LoadingIndicator: loadingIndicator,
                              }}
                              getOptionValue={(option) => option.id}
                              getOptionLabel={(option) => option.name}
                              onChange={(e) => {
                                setBrandName(e);
                                handleBrandChange(e);
                              }}
                              placeholder={BRANDS}
                              isSearchable={true}
                              styles={getUserFormSelectStyles(
                                errors.brandId,
                                rowData?.brandId
                              )}
                              className="w-100 font-14-px text-secondary"
                              id="brandId"
                              isDisabled
                              isLoading={
                                spinner(storesConstants.FETCH_ALL_BRANDS)
                              }
                            />
                          )}
                          rules={{
                            required: !(
                              rowData?.brandId ||
                              rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
                              localRole !== SUPER_ADMIN
                            ),
                          }}
                        />
                      </Col>
                    )}
                    {(isGroupAdmin() || isManagerAdmin()) && (
                      <Col
                        xs={12}
                        className="d-flex align-items-baseline justify-content-between w-100"
                      >
                        <h6 htmlFor="groupId" className="mt-2 col-3 col-lg-3">
                          Groups:
                        </h6>
                        <Controller
                          name="groupId"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              value={
                                localRole === GROUP
                                  ? groups.data || []
                                  : [
                                      {
                                        id: franchiseName?.id || emptyString,
                                        name: franchiseName?.name || GROUPS,
                                      },
                                    ]
                              }
                              options={
                                localRole !== GROUP && localRole !== MANAGER
                                  ? [
                                      { id: emptyString, name: GROUPS },
                                      ...(groups.data || []),
                                      { id: ADD, name: ADD_FRANCHISE },
                                    ]
                                  : groups.data
                              }
                              components={{
                                IndicatorSeparator: () => null,
                                LoadingIndicator: loadingIndicator,
                              }}
                              getOptionValue={(option) => option.id}
                              getOptionLabel={getOptionLabel}
                              placeholder={GROUPS}
                              isSearchable={true}
                              styles={{
                                ...getUserFormSelectStyles(
                                  errors.groupId,
                                  rowData?.groupId
                                ),
                                option: getOptionStyle,
                              }}
                              className="w-100 font-14-px text-secondary"
                              id="groupId"
                              isDisabled
                              isLoading={
                                spinner(groupsConstants.GROUPS_DATA)
                              }
                            />
                          )}
                          rules={{
                            required: !(
                              rowData?.groupId ||
                              rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
                              rowData?.roleId === roleTypeEnums.BRAND_ADMIN
                            ),
                          }}
                        />
                      </Col>
                    )}
                    {isManagerAdmin() && (
                      <Col
                        xs={12}
                        className="d-flex align-items-baseline justify-content-between w-100"
                      >
                        <h6 htmlFor="storeIds" className="mt-2 col-3 col-lg-3">
                          Stores:
                        </h6>
                        <div className="col-md-9 col-9">
                          <Controller
                            name="storeIds"
                            control={control}
                            render={({ field }) => (
                              <Select
                                {...field}
                                value={storesName}
                                closeMenuOnSelect={false}
                                options={allLocations?.data}
                                components={{
                                  Option,
                                  ValueContainer: ValueContainer,
                                  IndicatorSeparator: () => null,
                                  LoadingIndicator: loadingIndicator,
                                }}
                                isMulti
                                hideSelectedOptions={false}
                                maxMenuHeight={200}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.name}
                                placeholder="Select Stores"
                                isSearchable={true}
                                styles={{
                                  ...getUserFormSelectStyles(
                                    errors.storeIds,
                                    rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH
                                      ? rowData?.storeIds[0]
                                      : undefined
                                  ),
                                  option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isSelected
                                      ? "transparent"
                                      : emptyString,
                                    color: "black",
                                  }),
                                }}
                                className="w-100 font-14-px text-secondary"
                                id="storeIds"
                                isDisabled
                                isLoading={
                                  spinner(managersConstants.MANAGERS_DATA)
                                }
                              />
                            )}
                            rules={{
                              required: !(
                                rowData?.storeIds?.length > EMPTY_ARRAY_LENGTH ||
                                rowData?.roleId === roleTypeEnums.SUPER_ADMIN ||
                                rowData?.roleId === roleTypeEnums.GROUP ||
                                rowData?.roleId === roleTypeEnums.BRAND_ADMIN
                              ),
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="g-3">
                    <Col
                      xs={12}
                      className="d-flex align-items-baseline justify-content-between w-100"
                    >
                      <h6 htmlFor="name" className="mt-2 col-3 col-lg-2">
                        Name:
                      </h6>
                      <input
                        type="text"
                        name="name"
                        value={rowData?.name}
                        minLength={1}
                        maxLength={100}
                        {...register("name", {
                          required: !rowData?.name,
                          onChange: (e) => handleChange(e),
                        })}
                        className={`form-control user-fields font-14-px text-secondary w-100 ${getClassName(
                          errors.name,
                          "is-invalid"
                        )}`}
                      />
                    </Col>
                    <Col
                      xs={12}
                      className="d-flex align-items-baseline justify-content-between w-100"
                    >
                      <h6 htmlFor="email" className="mt-2 col-3 col-lg-2">
                        Email:
                      </h6>
                      <input
                        type="text"
                        name="email"
                        value={rowData?.email}
                        minLength={1}
                        maxLength={100}
                        {...register("email", {
                          required: !rowData?.email,
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Email is not valid",
                          },
                          onChange: (e) => handleChange(e),
                        })}
                        className={`form-control user-fields font-14-px text-secondary w-100 ${getClassName(
                          errors.email,
                          "is-invalid"
                        )}`}
                      />
                    </Col>
                    <Col
                      xs={12}
                      className="d-flex align-items-baseline justify-content-between w-100"
                    >
                      <h6 htmlFor="phone" className="mt-2 col-3 col-lg-2">
                        Phone:
                      </h6>
                      <Form.Group className="user-fields d-flex flex-column w-100">
                        <InputGroup className="d-flex w-100">
                          <InputGroup.Text
                            className={`fw-medium ${
                              errors.phoneNumber
                                ? "border border-danger"
                                : emptyString
                            }`}
                          >
                            {phoneConstants.COUNTRY_DISPLAY}
                          </InputGroup.Text>
                          <Form.Control
                            type="tel"
                            name="phoneNumber"
                            value={rowData?.phoneNumber}
                            minLength={phoneConstants.LENGTH}
                            maxLength={phoneConstants.LENGTH}
                            {...register("phoneNumber", {
                              required: !rowData?.phoneNumber,
                              pattern: {
                                value: phoneConstants.PATTERN,
                              },
                              onChange: (e) => {
                                if (!isNaN(e.target.value)) handleChange(e);
                              },
                            })}
                            className={`form-control  font-14-px text-secondary ${getClassName(
                              errors.phoneNumber,
                              "is-invalid"
                            )}`}
                          />
                        </InputGroup>
                        <Form.Text className="text-muted">
                          <ul className="ps-4">
                            <li
                              className={`${
                                rowData?.phoneNumber?.length ===
                                phoneConstants.LENGTH
                                  ? "text-success"
                                  : emptyString
                              }`}
                            >
                              <small>{phoneConstants.FORMAT_HINT}</small>
                            </li>
                          </ul>
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className="form-group mb-3 d-flex justify-content-between justify-content-sm-end py-2">
                <button
                  type="button"
                  className="btn user-permission-button px-4"
                  onClick={() => resetPasswordModal(authenticationUser?.id)}
                >
                  Change Password
                </button>
                <button
                  type="submit"
                  className="btn user-permission-button px-4 mx-1"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

//Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  storesReducer: state.storesReducer,
  groupsReducer: state.groupsReducer,
  managersReducer: state.managersReducer,
  managers: state.managersReducer.managers?.data,
  authenticationUser: state.authentication.user,
  imagePathFromHub: state.system.fromHub?.imagePath,
  userPermissionsReducer: state.userPermissionsReducer,
});

//Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getGroups: (brandId) => dispatch(groupsActions.getGroups(brandId)),
  getAllBrands: (isActiveOnly) =>
    dispatch(storeActions.getAllBrands(isActiveOnly)),
  getUserById: (userId) => dispatch(loginActions.getUserById(userId)),
  deleteUserProfileImage: (userId) =>
    dispatch(userPermissionsActions.deleteUserProfileImage(userId)),
  updateUserProfilePic: (data) =>
    dispatch(userPermissionsActions.updateUserProfilePic(data)),
  updateUsers: (rowData, userId, isUserProfile) =>
    dispatch(
      userPermissionsActions.updateUsers(rowData, userId, isUserProfile)
    ),
  getBrandlocations: (groupId) =>
    dispatch(managersActions.getBrandlocations(groupId)),
});

//Mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
